import { useMutation } from "@tanstack/react-query";
import { createDocument } from "../services/document.service";
import type { ICreateDocumentRequest } from "../types/document.types";

/**
 * Hook for creating a new document.
 * Callers are responsible for invalidating queries when appropriate.
 */
export const useCreateDocument = () => {
  return useMutation({
    mutationFn: (data: ICreateDocumentRequest) => createDocument(data),
    onError: (error) => {
      console.error("Failed to create document:", error);
    },
  });
};
